import { FormControl, FormLabel, Grid, Slider, Typography, TextField, IconButton } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const CantidadSesionesTaller = () => {
    const { promptData, setPromptData} = useActividadesContext();
    const handleSliderChange = (event, newValue) => {
        setPromptData((prevData) => ({
            ...prevData,
            cantidad_sesiones_taller: newValue,
        }));
    };

    const handleInputChange = (event) => {
        const newValue = event.target.value === '' ? '' : Number(event.target.value);
        setPromptData((prevData) => ({
            ...prevData,
            cantidad_sesiones_taller: newValue,
        }));
    };

    const handleIncrement = () => {
        setPromptData((prevData) => ({
            ...prevData,
            cantidad_sesiones_taller: Math.min(prevData.cantidad_sesiones_taller + 1, 10),
        }));
    };

    const handleDecrement = () => {
        setPromptData((prevData) => ({
            ...prevData,
            cantidad_sesiones_taller: Math.max(prevData.cantidad_sesiones_taller - 1, 1),
        }));
    };

    return (
        <Grid sx={{ mb: 3 }}>
            <FormControl component="fieldset">
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                    Cantidad de sesiones *
                </Typography>
                <FormLabel component="p" sx={{ fontFamily: 'montserrat', fontSize: '0.85rem', mt: 0.2 }}>
                Selecciona el total de sesiones que se dedicara a la implementación de este taller de aprendizaje
                </FormLabel>
                <Grid container alignItems="center" justifyContent="space-between" spacing={2} width={600}>
                    {/* Slider en la parte izquierda */}
                    <Grid item xs={6}>
                        <Slider
                            value={promptData.cantidad_sesiones_taller}
                            onChange={handleSliderChange}
                            step={1}
                            min={1}
                            max={10}
                            valueLabelDisplay="auto"
                            valueLabelFormat={(value) => `${value} sesiones`}
                            aria-labelledby="cantidad_sesiones_taller-slider"
                            sx={{
                                color: '#336B87',
                                '& .MuiSlider-markLabel': {
                                    color: '#336B87',
                                    fontFamily: 'montserrat',
                                },
                                '& .MuiSlider-valueLabel': {
                                    backgroundColor: '#F9DA96',
                                    color: '#209099',
                                    fontFamily: 'montserrat'
                                },
                            }}
                        />
                    </Grid>
                    {/* Contador en la parte derecha */}
                    <Grid item xs={6} container spacing={1}>
                        <Grid item>
                            <IconButton onClick={handleDecrement} disabled={promptData.cantidad_sesiones_taller <= 1}>
                                <Remove />
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <TextField

                                variant="standard"
                                value={promptData.cantidad_sesiones_taller}
                                onChange={handleInputChange}
                                inputProps={{
                                    step: 5,
                                    min: 5,
                                    max: 90,
                                    type: 'text',
                                    fontFamily: 'montserrat',
                                    color: '#336B87',
                                    sx: { fontFamily: 'montserrat', color: '#336B87', textAlign: 'center' }
                                }}
                                sx={{ width: 40, textAlign: 'center', fontFamily: 'montserrat', color: '#336B87' }}
                            />
                        </Grid>

                        <Grid item>
                            <IconButton onClick={handleIncrement} disabled={promptData.cantidad_sesiones_taller >= 10}>
                                <Add />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </FormControl>
        </Grid>
    );
};

export default CantidadSesionesTaller;
